import { createAction, createSlice } from '@reduxjs/toolkit';
export const resetStore = createAction('app/store/reset');
export const resetStoreNoReload = createAction('app/store/resetNoReload');
const initialState = {
    ActiveHTTPRequests: 0,
    ImmediateActiveRequests: 0,
    IsOnline: false,
};
export const loaderSlice = createSlice({
    name: 'loader',
    initialState,
    reducers: {
        showLoader: (state) => {
            state.ActiveHTTPRequests += 1;
        },
        hideLoader: (state) => {
            state.ActiveHTTPRequests = state.ActiveHTTPRequests > 1 ? state.ActiveHTTPRequests - 1 : 0;
        },
        showLoaderImmediate: (state) => {
            state.ImmediateActiveRequests += 1;
        },
        hideLoaderImmediate: (state) => {
            state.ImmediateActiveRequests = state.ImmediateActiveRequests > 1 ? state.ImmediateActiveRequests - 1 : 0;
        },
        setIsOnline: (state, action) => {
            state.IsOnline = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(resetStore, () => {
            localStorage.removeItem('persist:root');
            localStorage.clear();
            window.location.reload();
            return initialState;
        });
        builder.addCase(resetStoreNoReload, () => {
            localStorage.removeItem('persist:root');
            localStorage.clear();
            return initialState;
        });
    },
});
export const { showLoader, hideLoader, showLoaderImmediate, hideLoaderImmediate, setIsOnline } = loaderSlice.actions;
export default loaderSlice.reducer;
